<script>

	import { onMount } from 'svelte'
	import { createEventDispatcher } from 'svelte'
	import { fade, slide } from 'svelte/transition'

    import Applications from '../services/applications'
    import Users from '../services/user'
    import SignUpService from '../services/signup'
  	
	const dispatch = createEventDispatcher()

    let error = ""
    let user = {}
    let applicationsList = []
    let userId = null
	let visible = false

    onMount(async () => {})

	export const start = async (uid = null) => {
        if(!uid) return new Error("no uid provided")
           
        userId = uid
        let uresult = await Users.getOneUser(userId)
        console.log("uresult", uresult)
        if(uresult.success) user = uresult.data

        let aresult = await Applications.getApplications()
        if(aresult.success) applicationsList = aresult.data

        applicationsList = updateAppsList()

		visible = true
	}

	export const stop = (action = 'close', data = {}) => {
		dispatch('message', {
			action : action,
            data : data
		})
        error = ""
        user = {}
        userId = null
		visible = false
	}

    const update = async () => {

        let updatedUser = {}
        if(user.first_connection) updatedUser.first_connection = user.first_connection
        if(user.apps_list) updatedUser.apps = user.apps_list.map(el => el._id)

        let uresult = await Users.updateOneUser(userId, updatedUser)
        if(uresult.success) user = uresult.data
        if(!uresult.success) error = uresult.data

        stop('update', uresult)
    }

	const handleClose = () => {
		stop()
	}

    const updateAppsList = () => {
        const difference = [
            ...getDifference(user.apps_list, applicationsList),
            ...getDifference(applicationsList, user.apps_list)
        ]

        return difference
    }

    const pushToAppArray = (object) => {
        user.apps_list = user.apps_list.filter(element => {
            return element._id !== object._id
        })
        
        applicationsList.push(object)
        applicationsList = applicationsList
    }

    const pushToUserArray = (object) => {
        applicationsList = applicationsList.filter(element => {
            return element._id !== object._id
        })
        
        user.apps_list.push(object)
        user.apps_list= user.apps_list
    }
    
    const getDifference = (array1, array2) => {
        return array1.filter(object1 => {
            return !array2.some(object2 => {
                return object1._id === object2._id
            })
        })
    }

    const generateResetLink = async () => {
        let sresult = await SignUpService.generate({ username : user.username, type : 'reset' })
        if(sresult.success) stop('update', sresult)
        if(!sresult.success) error = sresult.data
    }

</script>

{#if visible}
    <div class="fullscreen" on:click={handleClose} transition:fade="{{ y: 200, duration: 200 }}"></div>
    <div class="container main-modal" transition:slide="{{ x: -200, duration: 200 }}">
        <div class="row p-0 m-0">
            <div class="col p-0 m-0">
                <h2 class="text-center" id="users">{user.username}</h2>
            </div>
            <div class="col-auto p-0 m-0">
                <button type="button" class="btn-close" aria-label="Close" on:click="{stop}"></button>
            </div>
        </div>
        <div class="row mt-3">
            <div class="col-md-6">

                <h4 class="mb-4">Accessible</h4>

                <div class="list-group">
                    {#if user.apps_list.length == 0}
                        <p>Aucune application n'est accessible à l'utilisateur.</p>
                    {/if}
                    {#each user.apps_list as application}
                        <button type="button" on:click={pushToAppArray(application)} class="list-group-item list-group-item-action">{application.name}</button>
                    {/each}
                </div>
            </div>
            <div class="col-md-6">
                <h4 class="mb-4">Non accessible</h4>
                <div class="list-group">
                    {#each applicationsList as application}
                        <button type="button" on:click={pushToUserArray(application)} class="list-group-item list-group-item-action">{application.name}</button>
                    {/each}
                </div>
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="col-md-6">
                <div class=" mt-4">
                    <button type="button" on:click={update} class="btn btn-dark w-100">Mettre à jour</button>
                </div>
            </div>
            <div class="col-md-6">
                <div class=" mt-4">
                    <button type="button" on:click={generateResetLink} class="btn btn-danger w-100">Reset Password</button>
                </div>
            </div>
        </div>

        <div class=" mt-4">
            
            
        </div>
    </div>
{/if}

<style>

    .fullscreen {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom : 0;
        background-color: rgba(0, 0, 0, 0.33);
    }

	.main-modal {
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background-color: white;
        border-radius: 15px;
        max-width: 100%;
        padding: 10px 35px 35px 35px;
        max-height: 100%;
        width: 650px;
        overflow: auto;
	}

</style>
